// The uid comes from the route, so a project that is gone - deleted elsewhere, a stale bookmark, access
// revoked - is a fact about the link, not an app bug. The toast already names the uid for the user, so
// reporting it only files one unactionable issue per uid.
const PROJECT_NOT_FOUND = /Project with uid `\d+` not found/;

export const isProjectNotFound = (message: string) => PROJECT_NOT_FOUND.test(message);
